export const PhotoCarousel = ({ images, direction = "left", speed = 35 }) => {
  const loop = [...images, ...images];
  const animationName = direction === "left" ? "tmp-marquee-left" : "tmp-marquee-right";

  return (
    <div className="overflow-hidden group" data-testid={`photo-carousel-${direction}`}>
      <div
        className="flex gap-4 w-max group-hover:[animation-play-state:paused]"
        style={{ animation: `${animationName} ${speed}s linear infinite` }}
      >
        {loop.map((img, i) => (
          <div key={`${img.id}-${i}`} className="w-48 sm:w-64 flex-shrink-0 rounded-2xl overflow-hidden">
            <img
              src={img.url}
              alt="Homegrown business at The Market Place, Jaipur"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
        ))}
      </div>
      <style>{`
        @keyframes tmp-marquee-left { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes tmp-marquee-right { from { transform: translateX(-50%); } to { transform: translateX(0); } }
      `}</style>
    </div>
  );
};
